<template>
  <div>
    <div :class="{ 'mt-30-px': !showNavbar }">
      <notifications></notifications>

      <navbar v-if="showNavbar" :docsName="docsName" />

      <!-- HEAD -->
      <!-- TODO: Headline Lehrganggruppe-Bezeichnung hinzufügen + Sprachvariable anpassen -->
      <div class="container-fluid row">
        <div v-if="showNavbar" class="col-xl-12">
          <div class="row">
            <div class="col-xl-12 block br-t-l-0 mb-3">
              <head-menu
                :col="12"
                class="d-xl-flex"
                :headline="$t('global.crosscurriculargradeoverview')"
              ></head-menu>

              <div class="row mt-2 d-flex">
                <!--<div class="ml-4">
                   <button
                    class="btn btn-primary"
                    @click="assignSelectedCertificates"
                  >
                    <span>Ausgewählte Zertifikate zuweisen</span>
                  </button>
                </div> -->
                <div class="ml-4">
                  <button class="mr-3 btn btn-primary" @click="abbrechen">
                    <span>{{ $t("global.cancel") }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- TABELLE -->
        <div class="row ml-0 w-100-p">
          <div class="col-12 block belegliste text-break">
            <div
              class="lehrgangsuebergreifendeNotenuebersichtsTabelle"
              v-if="loaded"
            >
              <b-table
                class="w-100-p"
                no-border-collapse
                responsive
                sticky-header="1000px"
                ref="selectableTable"
                small
                tbody-tr-class="item"
                :items="items"
                :fields="fields"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :busy="isBusy"
                show-empty
                selectable
                select-mode="range"
              >
                <template #thead-top="data">
                  <tr>
                    <th v-for="field in data.fields" :key="field.key">
                      <div
                        v-if="
                          field.key != 'name' &&
                          field.key != 'total_attendance' &&
                          field.label_category
                        "
                      >
                        {{ field.label_category }}
                      </div>
                    </th>
                  </tr>
                </template>

                <template #cell()="data">
                  <div v-if="data.value === ''">-</div>
                  <div v-else-if="isDispensiert(data.item, data.field.key)">
                    {{ $t("global.dispensed") }}
                  </div>
                  <div v-else-if="isAttendance(data.field.key)">
                    {{ data.value + "%" }}
                  </div>
                  <div v-else>{{ data.value }}</div>
                </template>

                <template #cell(certificate)="data">
                  <!-- <div
                    class="d-flex flex-wrap py-2"
                    :key="'moduleConfirmationButtons-' + data.index"
                  >
                    <button
                      class="btn btn-default mr-3 w-45-p"
                      @click="openShowModuleConfirmationModal(data)"
                    >
                      Modulbestätigung anzeigen
                    </button>
                    <button
                      class="btn btn-primary w-45-p"
                      @click="openAssignModuleConfirmationModal(data)"
                    >
                      Modulbestätigung zuweisen
                    </button>
                  </div> -->
                  <div
                    class="d-flex flex-wrap py-2"
                    :key="'certificateButtons-' + data.index"
                  >
                    <button
                      class="btn btn-default mr-3 w-45-p"
                      @click="openShowCertificateModal(data)"
                    >
                      {{ $t("global.showcertificate") }}
                    </button>
                    <button
                      class="btn btn-primary w-45-p"
                      @click="openAssignCertificateModal(data)"
                    >
                      {{ $t("global.assigncertificate") }}
                    </button>
                  </div>
                </template>

                <template #head(selected)="header">
                  <b-form-checkbox
                    ref="headerCheckbox"
                    v-model="header.selected"
                    @input="selectAllRows(header)"
                  ></b-form-checkbox>
                </template>

                <template #cell(selected)="row">
                  <b-form-checkbox
                    v-model="row.item.selected"
                    @input="onRowSelected(row)"
                  ></b-form-checkbox>
                </template>

                <template #table-busy>
                  <div class="text-center text-primary my-2">
                    <b-spinner class="align-middle"></b-spinner>
                  </div>
                </template>

                <template #empty>
                  <div v-if="ladeFehler" class="text-center text-danger my-2">
                    <strong>{{ $t("global.errorwhileloading") }}</strong>
                  </div>
                  <div v-if="!ladeFehler" class="text-center text-primary my-2">
                    <strong>{{ $t("global.nodataavailable") }}</strong>
                  </div>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <zertifikat-auswahl-modal
      :id="'zertifikat-anzeigen-modal'"
      :headerText="$t('global.configurepdf')"
      :okText="$t('global.viewpdf')"
      :languages="['DE', 'FR']"
      :certificateTypesText="$t('global.selectcertificatetype')"
      :certificateTypes="certificateTypes"
      @ok="showCertificate"
    />
    <zertifikat-auswahl-modal
      :id="'zertifikat-zuweisen-modal'"
      :headerText="$t('global.configurepdf')"
      :okText="$t('global.assignpdf')"
      :languages="['DE', 'FR']"
      :certificateTypesText="$t('global.selectcertificatetype')"
      :certificateTypes="certificateTypes"
      @ok="assignCertificate"
    />
    <!-- <zertifikat-auswahl-modal
      :id="'modulbestaetigung-anzeigen-modal'"
      :headerText="'Modulbestätigung konfigurieren'"
      :okText="'PDF anzeigen'"
      :languages="['DE', 'FR']"
      @ok="showModuleConfirmation"
    />
    <zertifikat-auswahl-modal
      :id="'modulbestaetigung-zuweisen-modal'"
      :headerText="'Modulbestätigung konfigurieren'"
      :okText="'PDF zuweisen'"
      :languages="['DE', 'FR']"
      @ok="assignModuleConfirmation"
    /> -->
    <pdf-layer
      id="pdf-layer"
      ref="pdfLayer"
      :src="{
        url: pdfPath,
        withCredentials: true,
      }"
    />
    <loading-overlay v-show="loading"></loading-overlay>
  </div>
</template>

  <script>
import HeadMenu from "@/components/HeadMenu";
import Navbar from "@/components/Navbar";
import ZertifikatAuswahlModal from "@/components/Modals/ZertifikatAuswahlModal";

import Api from "@/Api";
import PdfGeneratorApi from "@/PdfGeneratorApi";
import { BSpinner } from "bootstrap-vue";

import server from "@/server";
import page from "@/mixins/Page";

import { LADE_AUSWAHLWERTE_VERANSTALTUNG } from "@/store/veranstaltung/actions.type";

export default {
  name: "LehrgangsuebergreifendeNotenuebersicht",
  components: {
    HeadMenu,
    Navbar,
    ZertifikatAuswahlModal,
    BSpinner,
  },

  metaInfo() {
    return {
      titleTemplate: () => {
        return "BX: " + this.$t("global.crosscurriculargradeoverview");
      },
    };
  },
  mixins: [page],
  props: {
    lehrgangid: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isBusy: false,
      ladeFehler: false,
      selectedIds: [],
      selectedObjects: [],
      selectAll: null,
      pdfPath: "",
      loaded: true,
      sortBy: "name",
      sortDesc: false,
      activePerson: null,
      backgroundColors: [
        "#a5dde326", // Himmelblau
        "#ffd70026", // Goldgelb
        "#b19cd926", // Lavendel
        "#f5a62326", // Pastellorange
        "#f2b6c626", // Zartes Rosa
        "#f7dc6f26", // Hellgelb
        "#AAB7B826", // Graublau
        "#FAD02E26", // Hellgelb
        "#C39BD326", // Flieder
        "#D0E6A526", // Zartes Grün
        "#D5DBDB26", // Hellgrau
        "#F3D6E426", // Zartes Rosa
      ],
      overview: [],
      participants: [],
    };
  },
  computed: {
    fields() {
      const nameField = {
        key: "name",
        label: this.$t("global.name"),
      };

      const average_attendance = {
        key: "average_attendance",
        label: this.$t("global.totalattendance"),
      };

      const certificateButtons = {
        key: "certificate",
        label: this.$t("global.certificates"),
        tdClass: "certButtons",
      };

      const selected = { key: "selected", label: "", tdClass: "selection" };

      let categoryFields = [];
      this.overview.forEach((category, index) => {
        categoryFields.push({
          key: category.id + ".evaluation",
          label: this.$t("global.evaluation"),
          label_category: category.designation,
          tdClass: "tdBackgroundEvaluation",
        });
        categoryFields.push({
          key: category.id + ".attendance",
          label: this.$t("global.dashboard_presence"),
          tdClass: "tdBackgroundAttendance",
        });
      });

      return [
        selected,
        nameField,
        ...categoryFields,
        average_attendance,
        certificateButtons,
      ];
    },
    items() {
      const rows = [];

      for (const participant of this.participants) {
        const row = {
          name: participant.full_name,
          average_attendance: participant.average_attendance,
          gpid: participant.id,
        };

        for (const category of this.overview) {
          const correspondingItem = participant.course_categories.find(
            (item) => item.id === category.id
          );

          if (correspondingItem) {
            row[category.id] = {
              dispensed: correspondingItem.dispensed,
              evaluation: correspondingItem.evaluation,
              attendance: correspondingItem.average_attendance,
            };
          } else {
            row[category.id] = null;
          }
        }

        rows.push(row);
      }
      return rows;
    },
    certificateTypes: {
      get() {
        return this.sortedTypes();
      },
    },
  },
  watch: {},
  created() {},
  mounted() {
    if (this.certificateTypes?.length == 0) {
      this.$store.dispatch(`veranstaltung/${LADE_AUSWAHLWERTE_VERANSTALTUNG}`);
    }
    this.getNotenuebersicht();
  },
  methods: {
    sortedTypes() {
      return this.$store.state.veranstaltung.lehrgangsgruppen.sort(function (
        a,
        b
      ) {
        return a.pdf_identifier - b.pdf_identifier;
      });
    },
    async getNotenuebersicht() {
      this.isBusy = true;

      await Api.get("lehrgaenge/bewertungsuebersicht/", {
        params: {
          id: this.lehrgangid,
        },
      })
        .then((response) => {
          this.overview = response.data?.overview;
          this.participants = response.data?.participants;
          this.ladeFehler = false;
        })
        .catch((e) => {
          console.log(e);
          this.ladeFehler = true;
        })
        .finally(() => {
          this.isBusy = false;
        });

      this.styleTdElements();
    },
    abbrechen() {
      this.$router.push({
        name: "bildungsgang",
        params: { lehrgangid: this.lehrgangid, anzeige: 0 },
      });
    },

    // openShowModuleConfirmationModal(data) {
    //   this.activePerson = data.item.gpid;
    //   this.$bus.$emit("open-modal", "modulbestaetigung-anzeigen-modal");
    // },
    // showModuleConfirmation(json) {
    //   const reportName = "modulbestaetigung-" + json.language;

    //   this.pdfPath =
    //     server.url +
    //     `/pdfgenerator/pdf.act?filename=Modulbestaetigung_Weiterbildung.pdf&report=/pdfgenerator/${reportName}.htm&sgid=${this.lehrgangid}&ids=${this.activePerson}&date=${json.date}`;
    //   this.$refs.pdfLayer.show();
    // },
    // openAssignModuleConfirmationModal(data) {
    //   this.activePerson = data.item.gpid;
    //   this.$bus.$emit("open-modal", "modulbestaetigung-zuweisen-modal");
    // },
    // assignModuleConfirmation(json) {
    //   this.loading = true;

    //   const reportName = "modulbestaetigung-" + json.language;

    //   const pdfPath = `/pdfcache.act?filename=Modulbestaetigung_Weiterbildung.pdf&report=/pdfgenerator/${reportName}.htm&sgid=${this.lehrgangid}&ids=${this.activePerson}&date=${json.date}`;

    //   PdfGeneratorApi.get(pdfPath)
    //     .then((response) => {
    //       Api.post(
    //         "dokument/",
    //         {},
    //         {
    //           params: {
    //             id: this.activePerson,
    //             fileID: response.data.fileID,
    //             fileName: "Modulbestaetigung_Weiterbildung.pdf",
    //           },
    //         }
    //       ).then(() => {
    //         this.$notify({
    //           type: "success",
    //           title: this.$t("global.actionsuccessful"),
    //           duration: 5000,
    //           text: "PDFs erfolgreich der Person zugewiesen",
    //         });
    //       });
    //     })
    //     .catch(() => {
    //       this.$notify({
    //         type: "error",
    //         title: this.$t("global.actionfailed"),
    //         duration: 5000,
    //         text: "Fehler beim Zuweisen der PDFs",
    //       });
    //     })
    //     .finally(() => {
    //       this.loading = false;
    //     });
    // },

    openShowCertificateModal(data) {
      this.activePerson = data.item.gpid;
      this.$bus.$emit("open-modal", "zertifikat-anzeigen-modal");
    },
    showCertificate(json) {
      const fileName =
        "Zertifikat_Weiterbildung_" +
        json.certificateType?.bezeichnung?.replaceAll(" ", "_");

      const certificateNumber = json.certificateType.pdf_identifier;

      const reportName =
        "zertifikat-weiterbildung-" +
        certificateNumber +
        "-" +
        json.language +
        "-pdf";

      if (fileName && reportName) {
        this.pdfPath =
          server.url +
          `/pdfgenerator/pdf.act?filename=${fileName}.pdf&report=/pdfgenerator/${reportName}.htm&sgid=${this.lehrgangid}&ids=${this.activePerson}&date=${json.date}`;
        this.$refs.pdfLayer.show();
      }
    },
    openAssignCertificateModal(data) {
      this.activePerson = data.item.gpid;
      this.$bus.$emit("open-modal", "zertifikat-zuweisen-modal");
    },
    assignCertificate(json) {
      this.loading = true;

      const fileName =
        "Zertifikat_Weiterbildung_" +
        json.certificateType?.bezeichnung?.replaceAll(" ", "_");

      const certificateNumber = json.certificateType?.pdf_identifier;

      const reportName =
        "zertifikat-weiterbildung-" +
        certificateNumber +
        "-" +
        json.language +
        "-pdf";

      const pdfPath = `/pdfcache.act?filename=${fileName}.pdf&report=/pdfgenerator/${reportName}.htm&sgid=${this.lehrgangid}&ids=${this.activePerson}&date=${json.date}`;

      PdfGeneratorApi.get(pdfPath)
        .then((response) => {
          Api.post(
            "dokument/",
            {},
            {
              params: {
                id: this.activePerson,
                fileID: response.data.fileID,
                fileName: fileName + ".pdf",
              },
            }
          ).then(() => {
            this.$notify({
              type: "success",
              title: this.$t("global.actionsuccessful"),
              duration: 5000,
              text: this.$t("global.assignpdfsuccess"),
            });
          });
        })
        .catch(() => {
          this.$notify({
            type: "error",
            title: this.$t("global.actionfailed"),
            duration: 5000,
            text: this.$t("global.assignpdferror"),
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    isDispensiert(item, key) {
      const keys = key.split(".");

      if (keys[1] && keys[1] === "evaluation") {
        if (item[keys[0]]?.dispensed) {
          return true;
        }
      }

      return false;
    },
    isAttendance(key) {
      const keys = key.split(".");

      if (
        keys[0] === "average_attendance" ||
        (keys[1] && keys[1] === "attendance")
      ) {
        return true;
      }

      return false;
    },
    getBackgroundColor(index) {
      return this.backgroundColors[index] || "";
    },
    styleTdElements() {
      const table = this.$refs.selectableTable.$el;

      const tdElements = table.querySelectorAll("td");

      tdElements.forEach((td, index) => {
        if (td.className === "tdBackgroundEvaluation") {
          const colIndex = td.getAttribute("aria-colindex");

          let colorIndex = 0;

          //nimm anhand des Col-Indexes die nächste Farbe im backgroundColors-Array
          colorIndex = (colIndex - 3) / 2;

          if (colorIndex >= this.backgroundColors.length) {
            colorIndex =
              colorIndex -
              Math.floor(colorIndex / this.backgroundColors.length) *
                this.backgroundColors.length;
          }

          const backgroundColor = this.getBackgroundColor(colorIndex);

          td.style.backgroundColor = backgroundColor;
        } else if (td.className === "tdBackgroundAttendance") {
          const colIndex = td.getAttribute("aria-colindex");

          let colorIndex = 0;

          //nimm anhand des Col-Indexes die nächste Farbe im backgroundColors-Array
          colorIndex = (colIndex - 4) / 2;

          if (colorIndex >= this.backgroundColors.length) {
            colorIndex =
              colorIndex -
              Math.floor(colorIndex / this.backgroundColors.length) *
                this.backgroundColors.length;
          }

          const backgroundColor = this.getBackgroundColor(colorIndex);

          td.style.backgroundColor = backgroundColor;
        }
      });
    },
    getBackgroundColorTdClass(index) {
      const backgroundColor = this.getBackgroundColor(index);
      return {
        "background-color": backgroundColor,
      };
    },
    selectAllRows(row) {
      if (row.selected) {
        this.$refs.selectableTable.items.forEach((item) => {
          this.$set(item, "selected", true);
        });
        this.selectedObjects = this.$refs.selectableTable.items;
        this.selectedIds = this.$refs.selectableTable.items.map(
          (item) => item.gpid
        );
      } else {
        this.$refs.selectableTable.items.forEach((item) => {
          this.$set(item, "selected", false);
        });
        this.selectedIds = [];
        this.selectedObjects = [];
      }

      this.selectAll = Date.now();
    },
    onRowSelected() {
      if (this.selectAll) {
        let timeDiff = Date.now() - this.selectAll;
        if (timeDiff < 100) return;
      }
      this.selectedObjects = this.$refs.selectableTable.items.filter(
        (item) => item.selected
      );

      this.selectedIds = this.selectedObjects.map((item) => item.gpid);
    },
  },
};
</script>

<style lang="scss">
.lehrgangsuebergreifendeNotenuebersichtsTabelle
  .table
  > tbody
  > tr.b-table-row-selected {
  filter: brightness(95%);
  /*position: relative;*/
  z-index: 2;
}
.lehrgangsuebergreifendeNotenuebersichtsTabelle
  .table
  > thead
  > tr
  > th[aria-sort="ascending"],
.lehrgangsuebergreifendeNotenuebersichtsTabelle
  .table
  > thead
  > tr
  > th[aria-sort="descending"] {
  background-color: #a7c1cc;
}
.lehrgangsuebergreifendeNotenuebersichtsTabelle .table > thead > tr > th {
  cursor: pointer;
}
.lehrgangsuebergreifendeNotenuebersichtsTabelle
  .table
  > thead
  > tr
  > th:first-child {
  min-width: 31px;
}
.lehrgangsuebergreifendeNotenuebersichtsTabelle
  .table
  > thead
  > tr
  > th:nth-child(6) {
  min-width: 45px;
}
.lehrgangsuebergreifendeNotenuebersichtsTabelle
  .b-table-sticky-header
  > .table.b-table
  > thead
  > tr
  > th,
.lehrgangsuebergreifendeNotenuebersichtsTabelle
  .b-table-sticky-header
  > .table.b-table
  > thead
  > tr,
.lehrgangsuebergreifendeNotenuebersichtsTabelle
  .b-table-sticky-header
  > .table.b-table
  > thead {
  position: -webkit-sticky;
  position: sticky !important;
  top: 0;
  z-index: 10;
  background: #b5cfdc;
}
.lehrgangsuebergreifendeNotenuebersichtsTabelle .b-table-sticky-header {
  scrollbar-width: thin;
  scrollbar-color: #b5cfdc #f5fbff;
}
.lehrgangsuebergreifendeNotenuebersichtsTabelle .table {
  width: auto !important;
  min-width: 100%;
  overflow-x: scroll;
}
.lehrgangsuebergreifendeNotenuebersichtsTabelle .table td {
  min-width: 150px;
}

.lehrgangsuebergreifendeNotenuebersichtsTabelle .table td.certButtons {
  min-width: 500px;
}

.lehrgangsuebergreifendeNotenuebersichtsTabelle .table td.selection {
  min-width: 50px;
}
</style>
